<template>
  <mdb-container>
    <mdb-card class="text-left">
      <mdb-card-header class="primary-color text-white">
        <h4>Promotional Image</h4>
      </mdb-card-header>
      <mdb-card-body>
        <mdb-btn @click="doCancel" size="sm" rounded>
          <mdb-icon icon="arrow-left"/>
        </mdb-btn>
        <a v-if="event.promoImage" :href="event.promoImage" target="_blank"
           class="btn btn-default btn-sm btn-rounded ripple-parent" >
          <mdb-icon icon="external-link"/>View Current
        </a>

        <mdb-btn v-if="event.promoImage" size="sm" rounded icon="times-circle" @click="imageSelected(null)">Remove Current image</mdb-btn>
        <mdb-card class="mb-4">
          <mdb-card-body>
            Choose an image from your library below to use as the promotional image. It will not appear on the event viewer, but will
            be included at the top of email notices (announcements, reminders, etc.). It will also be used on event summaries shown
            on members' home page (e.g., "Up Next", etc.)
          </mdb-card-body>
        </mdb-card>
        <image-selector :group="group" emitOnSelection="imageSelected" @imageSelected="imageSelected" />
      </mdb-card-body>
    </mdb-card>
  </mdb-container>

</template>

<script>
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbChip,
  mdbContainer,
  mdbIcon,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';
import api from "../../services/groupsPlaceApi";
import ImageSelector from "../group/ImageSelector";

export default {
    name: 'PromoImageChooser',
    components: {
      mdbBtn,
      mdbCard,
      mdbCardBody,
      mdbCardHeader,
      mdbContainer,
      mdbChip,
      mdbTblBody,
      mdbTblHead,
      mdbTbl,
      mdbIcon,
      mdbBadge,
      ImageSelector
    },
    props: {
      event: {
        type: Object,
        default: null
      },
      type : {
        type: String,
        default: "event"
      }
    },
    computed: {
      userDetails() {
        return this.$store.state.userDetails
      },
      group() {
        return this.$store.state.currentGroup
      },
      executing() {
        return this.$store.state.executing
      }
    },

    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      imageSelected(img) {
        this.$store.dispatch("setExecuting", true);
        let payload = {}
        if (img) payload.image = img.id
        let url = "/event/setPromoImage/" + this.event.eventId
        api.post(url, payload).then(
          (results) => {
            if (img) this.event.promoImage = img.url
            else this.event.promoImage = null
            this.$emit("imageChosen", img ? img.url : null)
          },
          (error) => {
            this.$notify.error({message: "Could not set image. " + error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      doCancel() {
        this.$emit("close")
      },
    }
  }
  ;
</script>
